import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";


import { PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  button: {
    marginTop: 20,
  },
};


const ThankYou = () => {
  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.THANK_YOU]}
        path={PAGE_ROUTES.THANK_YOU}
      />

      <header className={"page-header standard-width"}>
        <h1 className={"section-head"}>Thank you</h1>
      </header>
 
      <section className={"thank-you-section standard-width"}>
        <p className={"thank-you-text"}>
          You should receive an email shortly with your guide or the next steps. Congratulations on taking this step to a healthier and <u>balanced</u> lifestyle!
        </p>
        <Link to={PAGE_ROUTES.HOME}>
          <Button
            variant={"contained"}
            color={"primary"}
            style={styles.button}
          >
            Back to Home
          </Button>
        </Link>

        <img
          className={"standard-box"}
          src={"/images/coming-soon.webp"}
          style={{ width: "100%", marginTop: 40 }}
          alt={"Thank you"}
        />
      </section>
    </main>
  );
};

export default ThankYou;

